import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import HeroSlider from "../../components/HeroSlider/HeroSlider";
import InstagramFeed from "../../components/InstagramFeed/InstagramFeed";
import WHCButton from "../../components/WHCButton/WHCButton";
import newsItems from "../../content/news";
import { formatDisplayDate, getLocale } from "../../utils/content";
import img7 from "../../assets/HeroSlider/hero7.jpg";
import img6 from "../../assets/HeroSlider/hero6.jpg";
import img2 from "../../assets/HeroSlider/hero2.jpg";
import styles from "./News.module.scss";

const images = [img6, img7, img2];

const News = () => {
  const { t, i18n } = useTranslation();
  const locale = getLocale(i18n.language);

  return (
    <section className={styles.news}>
      <HeroSlider label={t("hero_slider_news")} images={images} />

      <div className={styles.container}>
        <div className={styles.heading}>
          <h1>{t("news_title")}</h1>
          <p>{t("news_intro")}</p>
        </div>

        <div className={styles.grid}>
          {newsItems.map((item, index) => (
            <article
              key={item.id}
              className={`${styles.newsCard} ${
                index === 0 ? styles.featured : ""
              }`}
            >
              <div
                className={styles.cardImage}
                style={{ backgroundImage: `url(${item.image})` }}
              />

              <div className={styles.cardBody}>
                <div className={styles.cardMeta}>
                  <span>{item.category[locale]}</span>
                  <span>{formatDisplayDate(item.date, locale)}</span>
                </div>

                <h2>{item.title[locale]}</h2>
                <p>{item.excerpt[locale]}</p>

                {(item.location?.[locale] || item.time) && (
                  <div className={styles.cardDetails}>
                    {item.location?.[locale] && (
                      <span>{item.location[locale]}</span>
                    )}
                    {item.time && <span>{item.time}</span>}
                  </div>
                )}

                <div className={styles.cardActions}>
                  {item.actions.map((action) =>
                    action.external ? (
                      <a
                        key={action.link}
                        href={action.link}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <WHCButton>{action.label[locale]}</WHCButton>
                      </a>
                    ) : (
                      <Link key={action.link} to={action.link}>
                        <WHCButton variant="outline">
                          {action.label[locale]}
                        </WHCButton>
                      </Link>
                    )
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>

        <InstagramFeed />
      </div>
    </section>
  );
};

export default News;
